import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MouldForm from '../../../../components/masters/mould/mould/MouldForm';
import MouldTable from '../../../../components/masters/mould/mould/MouldTable';
import { fetchMoulds, addMould, updateMould, deleteMould, setMouldEdit, clearMouldEdit } from '../../../../redux/actions/masters/mould/mould/mouldActions';
import { fetchCompanies } from '../../../../api/masters/company/companyApi';
import { fetchUsers } from '../../../../redux/actions/masters/users/user/userAction';

const outerWrapper = {
  padding: 0,
  margin: 0,
  minHeight: 'calc(100vh - 72px)',
  display: 'flex',
  flexDirection: 'column',
  background: 'transparent',
  marginTop: 24,
};

const containerStyle = {
  display: 'flex',
  flexDirection: 'row',
  gap: 24,
  alignItems: 'stretch',
  width: '100%',
  height: '100%',
  flex: 1,
};

const cardBase = {
  background: '#fff',
  borderRadius: 16,
  boxShadow: '0 2px 16px rgba(0,0,0,0.07)',
  padding: '2rem 1.5rem',
  display: 'flex',
  flexDirection: 'column',
  minWidth: 320,
  flex: 1,
  minHeight: 520,
};

const formContainer = {
  ...cardBase,
  maxWidth: 400,
  flex: '0 1 400px',
  marginRight: 0,
};
const tableContainer = {
  ...cardBase,
  flex: 2,
  minWidth: 340,
  marginLeft: 0,
};

const responsiveStyle = `
@media (max-width: 900px) {
  .mould-flex {
    flex-direction: column !important;
    gap: 20px !important;
  }
  .mould-form, .mould-table {
    max-width: 100% !important;
    min-width: 0 !important;
    width: 100% !important;
  }
}
`;

const MouldPage = () => {
  const dispatch = useDispatch();
  const { list = [], loading, editingMould, formSuccess, formError } = useSelector(state => state.mould || {});
  const users = useSelector(state => state.users.list || []);
  const [companies, setCompanies] = useState([]);
  const [formSuccessMsg, setFormSuccessMsg] = useState('');
  const [formErrorMsg, setFormErrorMsg] = useState('');
  const [formResetKey, setFormResetKey] = useState(0);

  useEffect(() => {
    dispatch(fetchMoulds());
    dispatch(fetchUsers());
    fetchCompanies().then(data => setCompanies(data.filter(c => c.trash === 0)));
  }, [dispatch]);

  useEffect(() => {
    setFormSuccessMsg(formSuccess || '');
  }, [formSuccess]);
  useEffect(() => {
    setFormErrorMsg(formError || '');
  }, [formError]);

  const handleFormReset = () => {
    setFormResetKey(prev => prev + 1);
    setFormSuccessMsg('');
    setFormErrorMsg('');
    dispatch(clearMouldEdit());
  };

  const handleSubmit = async (form) => {
    if (editingMould && editingMould.mould_id) {
      await dispatch(updateMould(editingMould.mould_id, form));
      setFormErrorMsg('');
    } else {
      await dispatch(addMould(form));
      setFormErrorMsg('');
    }
  };

  const handleEdit = (mould) => {
    dispatch(setMouldEdit(mould));
    setFormSuccessMsg('');
    setFormErrorMsg('');
  };

  const handleDelete = (id) => {
    dispatch(deleteMould(id));
  };

  const handleCancel = () => {
    dispatch(clearMouldEdit());
    setFormSuccessMsg('');
    setFormErrorMsg('');
  };

  // Uniqueness check for code (used in form)
  const checkCodeExists = async (code, excludeId) => {
    const match = list.find(
      m => m.mould_code === code && (!excludeId || m.mould_id !== excludeId)
    );
    return !!match;
  };

  return (
    <div style={outerWrapper}>
      <style>{responsiveStyle}</style>
      <div style={containerStyle} className="mould-flex">
        <div style={tableContainer} className="mould-table">
          <MouldTable
            onNew={handleFormReset}
            moulds={list}
            onEdit={handleEdit}
            onDelete={handleDelete}
            loading={loading}
          />
        </div>
        <div style={formContainer} className="mould-form">
          <MouldForm
            key={formResetKey}
            onSubmit={handleSubmit}
            editingMould={editingMould}
            onCancel={handleCancel}
            formSuccess={formSuccessMsg}
            formError={formErrorMsg}
            setFormSuccess={setFormSuccessMsg}
            setFormError={setFormErrorMsg}
            companies={companies}
            users={users}
            checkCodeExists={checkCodeExists}
          />
        </div>
      </div>
    </div>
  );
};

export default MouldPage; 